import { Caldo, Caldopng, Charal, Chilaquilespng, ChilaquilesRojos, ChileRelleno, ChileRellenopng, Chongos, Chongospng, Churipo, Churipopng, Conserva, Conservapng, Corunda, Corundaconcarne, Corundaspng, EnchiladasPollo, EnchiladasPollopng, EnchiladasSinpng, Huarache, Huarachepng, Huevos, Huevosgustopng, Mole, Molepng, Pambazo, Pambazopng, Quesadilla, Quesadillapng, Sope, Sopespng, Taco, TacodeCharalpng, TacoGuisadopng, Torta, Tortapng, Uchepo, Uchepopng, Uchepotradpng, UchepoZanahoria } from '../assets';
import { Caldoglb, Huevosglb, Chilaquilesglb, Uchepoglb, UchepoTradicionalglb, Chilerellenoglb, Chongosglb, Churipoglb, Conservaglb, Corundascarneglb, Corundasglb, Enchiladasglb, EnchiladasPolloglb, Huaracheglb, Moleglb, Pambazoglb, Quesadillaglb, Sopesglb, TacodeCharalglb, Tacosglb, Tortaglb } from '../models';

// TODO: Añadir platillos Comida
// TODO: Añadir traducciones nexus comida
// TODO: Añadir platillos Desayuno
// TODO: Añadir traducciones nexus desayunos
// TODO: Añadir bebidas
// TODO: Añadir sección sin realidad aumentada y sólo con fotografía

// Comidas
export const Menu = [
    {
        id: "0",
        nombre: "tcaldo",
        descripcion: "caldo",
        glb: Caldoglb,
        principal: Caldo,
        portada: Caldopng,
    },   
    {
        id: "1",
        nombre: "tchilerelleno",
        descripcion: "chilerelleno",
        glb: Chilerellenoglb,
        principal: ChileRelleno,
        portada: ChileRellenopng,
    },
    {
        id: "2",
        nombre: "tchongos",
        descripcion: "chongos",
        glb: Chongosglb,
        principal: Chongos,
        portada: Chongospng,
    },
    {
        id: "3",
        nombre: "tchuripo",
        descripcion: "churipo",
        glb: Churipoglb,
        principal: Churipo,
        portada: Churipopng,
    }, 
    {
        id: "4",
        nombre: "tconserva",
        descripcion: "conserva",
        glb: Conservaglb,
        principal: Conserva,
        portada: Conservapng,
    }, 
    {
        id: "5",
        nombre: "tcorunda",
        descripcion: "corunda",
        glb: Corundasglb,
        principal: Corunda,
        portada: Corundaspng,
    }, 
    {
        id: "6",
        nombre: "tcorundacarne",
        descripcion: "corundacarne",
        glb: Corundascarneglb,
        principal: Corundaconcarne,
        portada: Corundaconcarne,
    }, 
    {
        id: "7",
        nombre: "tenchiladaspollo",
        descripcion: "enchiladaspollo",
        glb: EnchiladasPolloglb,
        principal: EnchiladasPollo,
        portada: EnchiladasPollopng,
    }, 
    {
        id: "8",
        nombre: "tenchiladas",
        descripcion: "enchiladas",
        glb: Enchiladasglb,
        principal: EnchiladasPollo,
        portada: EnchiladasSinpng,
    },
    {
        id: "9",
        nombre: "thuarache",
        descripcion: "huarache",
        glb: Huaracheglb,
        principal: Huarache,
        portada: Huarachepng,
    }, 
    {
        id: "10",
        nombre: "tmole",
        descripcion: "mole",
        glb: Moleglb,
        principal: Mole,
        portada: Molepng,
    }, 
    {
        id: "11",
        nombre: "tpambazo",
        descripcion: "pambazo",
        glb: Pambazoglb,
        principal: Pambazo,
        portada: Pambazopng,
    }, 
    {
        id: "12",
        nombre: "tquesadilla",
        descripcion: "quesadilla",
        glb: Quesadillaglb,
        principal: Quesadilla,
        portada: Quesadillapng,
    }, 
    {
        id: "13",
        nombre: "tsopes",
        descripcion: "sopes",
        glb: Sopesglb,
        principal: Sope,
        portada: Sopespng,
    }, 
    {
        id: "14",
        nombre: "ttacoscharal",
        descripcion: "tacoscharal",
        glb: TacodeCharalglb,
        principal: Charal,
        portada: TacodeCharalpng,
    }, 
    {
        id: "15",
        nombre: "ttacoguisado",
        descripcion: "tacoguisado",
        glb: Tacosglb,
        principal: Taco,
        portada: TacoGuisadopng,
    }, 
    {
        id: "16",
        nombre: "ttorta",
        descripcion: "torta",
        glb: Tortaglb,
        principal: Torta,
        portada: Tortapng,
    }, 
    {
        id: "17",
        nombre: "tuchepozanahoria",
        descripcion: "uchepozanahoria",
        glb: Uchepoglb,
        principal: UchepoZanahoria,
        portada: Uchepopng,
    }, 
    {
        id: "18",
        nombre: "tuchepo",
        descripcion: "uchepo",
        glb: UchepoTradicionalglb,
        principal: Uchepo,
        portada: Uchepotradpng,
    }, 
 ]
// Desayunos
 export const Desayuno = [
    {
        id: "0",
        nombre: "tquesadilla",
        descripcion: "quesadilla",
        glb: Quesadillaglb,
        principal: Quesadilla,
        portada: Quesadillapng,
    }, 
    {
        id: "1",
        nombre: "tsopes",
        descripcion: "sopes",
        glb: Sopesglb,
        principal: Sope,
        portada: Sopespng,
    }, 
    {
        id: "2",
        nombre: "ttacoscharal",
        descripcion: "tacoscharal",
        glb: TacodeCharalglb,
        principal: Charal,
        portada: TacodeCharalpng,
    }, 
    {
        id: "3",
        nombre: "ttacoguisado",
        descripcion: "tacoguisado",
        glb: Tacosglb,
        principal: Taco,
        portada: TacoGuisadopng,
    }, 
    {
        id: "4",
        nombre: "ttorta",
        descripcion: "torta",
        glb: Tortaglb,
        principal: Torta,
        portada: Tortapng,
    }, 
    {
        id: "5",
        nombre: "tpambazo",
        descripcion: "pambazo",
        glb: Pambazoglb,
        principal: Pambazo,
        portada: Pambazopng,
    }, 
    {
        id: "6",
        nombre: "thuarache",
        descripcion: "huarache",
        glb: Huaracheglb,
        principal: Huarache,
        portada: Huarachepng,
    }, 
    {
        id: "7",
        nombre: "tenchiladaspollo",
        descripcion: "enchiladaspollo",
        glb: EnchiladasPolloglb,
        principal: EnchiladasPollo,
        portada: EnchiladasPollopng,
    }, 
    {
        id: "8",
        nombre: "tenchiladas",
        descripcion: "enchiladas",
        glb: Enchiladasglb,
        principal: EnchiladasPollo,
        portada: EnchiladasSinpng,
    },
    {
        id: "9",
        nombre: "tconserva",
        descripcion: "conserva",
        glb: Conservaglb,
        principal: Conserva,
        portada: Conservapng,
    }, 
    {
        id: "10",
        nombre: "tchongos",
        descripcion: "chongos",
        glb: Chongosglb,
        principal: Chongos,
        portada: Chongospng,
    },
    {
        id: "11",
        nombre: "tchilaquiles",
        descripcion: "chilaquiles",
        glb: Chilaquilesglb,
        principal: ChilaquilesRojos,
        portada: Chilaquilespng,
    },
    {
        id: "13",
        nombre: "thuevos",
        descripcion: "huevos",
        glb: Huevosglb,
        principal: Huevos,
        portada: Huevosgustopng,
    },
 ]